(function () {
    "use strict";
    angular.module("app.core").config([
        "$stateProvider",
        function ($stateProvider) {
            $stateProvider
                .state("localInfo", {
                    url: "/:langcode",
                    abstract: true,
                    templateUrl: "app/localInformation/views/localInfo.html",
                    controller: "LocalInfoController",
                    params: {
                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        }
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'localInfo');
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            $translatePartialLoader.addPart("property_details");
                            $translatePartialLoader.addPart("analysis_houseOpportDetail");
                            $translatePartialLoader.addPart("opportunity");
                            $translatePartialLoader.addPart("valuation_house_details");
                            return $translate.refresh();
                        }],
                    },
                })
                .state("localInfo.property", {
                    // Property LocalInfo
                    url: "/{path:listing|firsat-emlak-ilan|anuncio}/:name/:id",

                    views: {
                        main: {
                            templateUrl: "app/localInformation/views/localProperties/localProperties.html",
                            controller: "LocalPropertiesController",
                            controllerAs: "vm",
                        },
                        // child modules for property page
                        "propertyHeader@localInfo.property": {
                            templateUrl: "app/localInformation/views/localProperties/PropertyHeader/propertyHeader.html",
                            controller: "PropertyHeaderController",
                            controllerAs: "vm",
                        },
                        "propertyInfoMain@localInfo.property": {
                            templateUrl: "app/localInformation/views/localProperties/PropertyMainInfo/propertyMainInfo.html",
                            controller: "LocalMainInfoController",
                            controllerAs: "vm",
                        },
                        "propertyDetails@localInfo.property": {
                            templateUrl: "app/localInformation/views/localProperties/PropertyDetails/propertyDetails.html",
                            controller: "PropertyDetailsController",
                            controllerAs: "vm",
                        },
                    },
                    resolve: {

                        LangProtect: ['routeHelpers', function(routeHelpers) {
                            return routeHelpers.langProtect('localInfo');
                        }],
                        comparable: function () { return null; },
                        geo: function () { return null; },

                        opportById: [
                            "opportunitiesGetApi",
                            "$transition$",
                            "$q",
                            "$rootScope",
                            "$translate",
                            "$timeout",
                            "historyService",
                            function (opportunitiesGetApi, $transition$, $q, $rootScope, $translate, $timeout, historyService) {
                                var deferrer = $q.defer();
                                if (!$transition$.params().id) deferrer.resolve(null);
                                else {
                                    var isIdString = typeof $transition$.params().id !== "number" ? $transition$.params().id.split("-").pop() : $transition$.params().id;
                                    var isId = parseInt(isIdString);
                                    // $http
                                    //     .get("https://pro.ip-api.com/json/?key=oeEJpK6wjHS9CN2")
                                    //     .then(
                                    //         function (res) {
                                    //             portfolioById
                                    //                 .getByIdIp(res.data.query)
                                    //                 .query({ portfolioId: isId })
                                    //                 .$promise.then(
                                    //                     function (result) {
                                    //                         deferrer.resolve(result);
                                    //                     },
                                    //                     function () {
                                    //                         deferrer.resolve(null);
                                    //                     }
                                    //                 );
                                    //         },
                                    //         function () {
                                    opportunitiesGetApi
                                        .getById({ portfolioId: isId })
                                        .$promise.then(
                                            function (result) {
                                                if (result && result.Details && result.Details.length) {
                                                    const currentDetails = result.Details.find(m => m.Language === window.langCode());
                                                    if (currentDetails)
                                                        if (currentDetails.Url !== $transition$.params().name) {
                                                            $timeout(function () {
                                                                $rootScope.MetaTags.prerender.statusCode = 301;
                                                                window.redirected = "Location: " + $transition$.router.stateService.href("localInfo.property", { langcode: $transition$.params().langcode, name: currentDetails.Url, path: $translate.instant("localInfo"), id: $transition$.params().id });
                                                                $rootScope.MetaTags.prerender.header = window.redirected;
                                                            });
                                                            $transition$.abort();
                                                            $transition$.router.stateService.go("localInfo.property", { langcode: $transition$.params().langcode, name: currentDetails.Url, path: $translate.instant("localInfo"), id: $transition$.params().id });
                                                            deferred.resolve();
                                                        }
                                                        else {
                                                            if (result.UrlHistory && result.UrlHistory.length)
                                                                window.listingUrls = result.UrlHistory.filter(m => m.IsActive);

                                                            historyService.set('opportunity', isId);

                                                            deferrer.resolve(result);
                                                        }
                                                    else
                                                        deferrer.resolve(null);
                                                }
                                                else {
                                                    deferrer.resolve(null);
                                                }
                                            },
                                            function () {
                                                deferrer.resolve(null);
                                            }
                                        );
                                    //     }
                                    // );
                                }
                                return deferrer.promise;
                            }
                        ],

                        // user: [
                        //     "user_factory",
                        //     "$transition$",
                        //     "$q",
                        //     "opportById",
                        //     function (user_factory, $transition$, $q, opportById) {
                        //         var deferrer = $q.defer();
                        //         var uid = $transition$.params().uid;
                        //         if (!uid && opportById.UserId) {
                        //             user_factory.get({ userId: opportById.UserId }).$promise.then(function (result) {
                        //                 deferrer.resolve(result.information);
                        //             }).catch(() => {
                        //                 deferrer.resolve(null);
                        //             });
                        //         }
                        //         else {
                        //             user_factory.get({ userId: uid }).$promise.then(function (result) {
                        //                 deferrer.resolve(result.information);
                        //             }).catch(() => {
                        //                 deferrer.resolve(null);
                        //             });
                        //         }
                        //         return deferrer.promise;
                        //     },
                        // ],

                        resolveAPIs: [
                            "searchParserService",
                            "$transition$",
                            "opportById",
                            // "notifierSvc",
                            //"$rootScope",
                            // "$timeout",
                            function (
                                searchParserService,
                                $transition$,
                                opportById,
                                // notifierSvc,
                                //$rootScope
                                // $timeout
                            ) {
                                if (!opportById) {
                                    // $transition$.abort();
                                    // $transition$.router.stateService.go("404", { langcode: $transition$.params().langcode });
                                    // $timeout(function () {
                                    //     $rootScope.MetaTags.prerender.statusCode = 301;
                                    //     window.redirected = "Location: " + $transition$.router.stateService.href("analysis.country.opportunity", { langcode: $transition$.params().langcode, country: "world" });
                                    //     $rootScope.MetaTags.prerender.header = window.redirected;
                                    // }, 0);
                                    $transition$.abort();
                                    $transition$.router.stateService.go("analysis.country.opportunity", { langcode: $transition$.params().langcode, country: "world" });

                                    // var translation = $transition$.params().langcode === 'tr' ? "Bu fırsat yayından kalktı. Aynı bölgedeki diğer fırsatları inceleyebilirsiniz." : "This property is not available anymore. You can check other opportunities around.";
                                    // notifierSvc.show({ message: translation, type: "info" });

                                    // var keys = $transition$.params().id.split("-");
                                    // if (keys.length > 2) {
                                    //     $timeout(function () {
                                    //         $rootScope.MetaTags.prerender.statusCode = 301;
                                    //         window.redirected = "Location: " + $transition$.router.stateService.href("analysis.province.opportunity", { langcode: $transition$.params().langcode, province: keys[0], county: keys[1] });
                                    //         $rootScope.MetaTags.prerender.header = window.redirected;
                                    //     }, 0);
                                    //     $transition$.abort();
                                    //     $transition$.router.stateService.go("analysis.province.opportunity", { langcode: $transition$.params().langcode, province: keys[0], county: keys[1] });

                                    // } else {
                                    //     $timeout(function () {
                                    //         $rootScope.MetaTags.prerender.statusCode = 301;
                                    //         window.redirected = "Location: " + $transition$.router.stateService.href("analysis.province.opportunity", { langcode: $transition$.params().langcode, province: "turkiye" });
                                    //         $rootScope.MetaTags.prerender.header = window.redirected;
                                    //     }, 0);
                                    //     $transition$.abort();
                                    //     $transition$.router.stateService.go("analysis.province.opportunity", { langcode: $transition$.params().langcode, province: "turkiye" });
                                    // }
                                } else {
                                    return searchParserService.parseSearchForOpportunity(
                                        opportById,
                                        $transition$.params()
                                    );
                                }
                            },
                        ],

                        titleOpp: ['opportById', function (opportById) {
                            if (!opportById) {
                                return "";
                            } else {
                                return opportById.Details.find(m => m.Language === window.langCode()).Title;
                            }
                        }],

                        descOpp: ['opportById', function (opportById) {
                            if (!opportById) {
                                return "";
                            } else {
                                return opportById.Details.find(m => m.Language === window.langCode()).Description;
                            }
                        }],

                        imgOpp: ['opportById', function (opportById) {
                            if (!opportById) {
                                return "";
                            } else return opportById.Photos.length ? opportById.Photos[0].replace("https://", "http://") : "";
                        }],
                        imgOppSecure: ['opportById', function (opportById) {
                            if (!opportById) {
                                return "";
                            } else return opportById.Photos.length ? opportById.Photos[0].replace("http://", "https://") : "";
                        }],

                    },
                    metaTags: {
                        title: "{{titleOpp}}",
                        description: "{{descOpp}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "{{imgOpp}}",
                            "og:image:secure_url": "{{imgOppSecure}}",
                            "og:type": "website",
                        },
                    },
                    params: {
                        path: ['$translate', function ($translate) {
                            return $translate.instant("localInfo");
                        }],
                        id: {
                            type: "any",
                            raw: true,
                            dynamic: false
                        },
                        name: {
                            type: "any",
                            raw: true,
                            dynamic: false
                        },
                    }
                })
                .state("localInfo.share", {
                    // Property LocalInfo
                    url: "/ps/:uid/:sid/:cid",
                    views: {
                        main: {
                            templateUrl: "app/localInformation/views/localProperties/localProperties.html",
                            controller: "LocalPropertiesController",
                            controllerAs: "vm",
                        },
                        // child modules for property page
                        "propertyHeader@localInfo.share": {
                            templateUrl: "app/localInformation/views/localProperties/PropertyHeader/propertyHeader.html",
                            controller: "PropertyHeaderController",
                            controllerAs: "vm",
                        },
                        "propertyInfoMain@localInfo.share": {
                            templateUrl: "app/localInformation/views/localProperties/PropertyMainInfo/propertyMainInfo.html",
                            controller: "LocalMainInfoController",
                            controllerAs: "vm",
                        },
                        "propertyDetails@localInfo.share": {
                            templateUrl: "app/localInformation/views/localProperties/PropertyDetails/propertyDetails.html",
                            controller: "PropertyDetailsController",
                            controllerAs: "vm",
                        },
                    },
                    resolve: {
                        opportById: function () { return null; },

                        comparable: [
                            "shareAPI",
                            "$transition$",
                            "$q",
                            "comparablesApi",
                            function (shareAPI, $transition$, $q, comparablesApi) {
                                var deferrer = $q.defer();
                                var cid = $transition$.params().cid;
                                var sid = $transition$.params().sid;
                                if (!cid || !sid) deferrer.resolve(null);
                                else {
                                    shareAPI
                                        .view({ sharedId: sid, comparableId: cid.substring(5) })
                                        .$promise.then(function () { });
                                    shareAPI.get({ sharedId: sid }).$promise.then(
                                        function (result) {
                                            for (var y = 0; y < result.Comparables.length; y++) {
                                                var comp = result.Comparables[y];
                                                if (comp.EndeksaId == cid) {
                                                    comparablesApi.detail({EndeksaId: comp.EndeksaId, captchaTokenCustom: window.ecSec()}).$promise.then(function (detailResult) {
                                                        detailResult.ShowSellerAgent = comp.ShowSellerAgent;
                                                        deferrer.resolve(detailResult);
                                                    });
                                                    return;
                                                }
                                            }

                                            deferrer.resolve(null);
                                        },
                                        function () {
                                            deferrer.resolve(null);
                                        }
                                    );

                                    //urlSearchApi.get({ listingurl: +cid }).$promise.then(function (result) {
                                    //    deferrer.resolve(result);
                                    //}, function () {
                                    //    deferrer.resolve(null);
                                    //});
                                }
                                return deferrer.promise;
                            },
                        ],

                        geo: [
                            "geoApi",
                            "$q",
                            "comparable",
                            function (geoApi, $q, comparable) {
                                var deferrer = $q.defer();
                                if (!comparable) deferrer.resolve(null);
                                else {
                                    var geoAp = geoApi.get({
                                        lat: +comparable.Latitude,
                                        long: +comparable.Longitude,
                                        level: 3
                                    });
                                    geoAp.$promise.then(
                                        function (resb) {
                                            deferrer.resolve(resb);
                                        },
                                        function () {
                                            deferrer.resolve(null);
                                        }
                                    );
                                }
                                return deferrer.promise;
                            },
                        ],

                        resolveAPIs: [
                            "searchParserService",
                            "$transition$",
                            "comparable",
                            // "notifierSvc",
                            // "$rootScope",
                            // "$timeout",
                            function (
                                searchParserService,
                                $transition$,
                                comparable
                                // notifierSvc,
                                // $rootScope,
                                // $timeout
                            ) {
                                if (!comparable) {

                                    // var translation = $transition$.params().langcode === 'tr' ? "Bu forsat yayından kalktı. Aynı bölgedeki diğer fırsatları inceleyebilirsiniz." : "This deal is not available anymore. You can check other opportunities around.";
                                    // notifierSvc.show({ message: translation, type: "info" });

                                    // var keys = $transition$.params().id.split("-");
                                    // if (keys.length > 2) {
                                    //     $timeout(function () {
                                    //         $rootScope.MetaTags.prerender.statusCode = 301;
                                    //         window.redirected = "Location: " + $transition$.router.stateService.href("analysis.province.opportunity", { langcode: $transition$.params().langcode, province: keys[0], county: keys[1] });
                                    //         $rootScope.MetaTags.prerender.header = window.redirected;
                                    //     }, 0);
                                    //     $transition$.abort();
                                    //     $transition$.router.stateService.go("analysis.province.opportunity", { langcode: $transition$.params().langcode, province: keys[0], county: keys[1] });

                                    // } else {
                                    //     $timeout(function () {
                                    //         $rootScope.MetaTags.prerender.statusCode = 301;
                                    //         window.redirected = "Location: " + $transition$.router.stateService.href("analysis.province.opportunity", { langcode: $transition$.params().langcode, province: "turkiye" });
                                    //         $rootScope.MetaTags.prerender.header = window.redirected;
                                    //     }, 0);
                                    //     $transition$.abort();
                                    //     $transition$.router.stateService.go("analysis.province.opportunity", { langcode: $transition$.params().langcode, province: "turkiye" });
                                    // }
                                } else {
                                    return searchParserService.parseSearchForOpportunity(
                                        comparable,
                                        $transition$.params()
                                    );
                                }
                            },
                        ],

                        titleOpp: ['comparable', function (comparable) {
                            return comparable.Title;
                        }],

                        descOpp: ['comparable', function (comparable) {
                            return comparable.Description;
                        }],

                        imgOpp: ['comparable', function (comparable) {
                            return comparable.Image.replace("https://", "http://");
                        }],
                        imgOppSecure: ['comparable', function (comparable) {
                            return comparable.Image.replace("http://", "https://");
                        }]
                    },
                    metaTags: {
                        title: "{{titleOpp}}",
                        description: "{{descOpp}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "{{imgOpp}}",
                            "og:image:secure_url": "{{imgOppSecure}}",
                            "og:type": "website",
                        },
                    },
                    params: {
                        cid: {
                            type: "any",
                            raw: true,
                            dynamic: false,
                        },
                        uid: {
                            type: "any",
                            raw: true,
                            dynamic: false,
                        },
                        sid: {
                            type: "any",
                            raw: true,
                            dynamic: false,
                        },
                    }
                });
        },
    ]);
})();
